import * as types from "../Actions/Types";
import { IUser } from "../Models/Models";
import { IOktaMFAFactor } from "../Models/OktaModels/IOktaMFAFactor";

export interface IUserProfileStore {
  currentUser: IUser;
  allMFAFactors: IOktaMFAFactor[];
  selectedMFAFactorID: string;
  waitingForMFAResponse: boolean;
  mfaResult: string;
  showMfaEnrollmentModal: boolean;
  mfaEnrollmentModalText: string;
  mfaEnrollmentUpdatedThisSession: boolean;
}

const defaultStore: IUserProfileStore = {
    currentUser: null,
    allMFAFactors: null,
    selectedMFAFactorID: "",
    waitingForMFAResponse: false,
    mfaResult: "",
    showMfaEnrollmentModal: false,
    mfaEnrollmentModalText: "",
    mfaEnrollmentUpdatedThisSession: false,
};

export const userProfile = (
    userProfileStore: IUserProfileStore = defaultStore,
    action
) => {
    switch (action.type) {
    // FAILURE
        case types.UPDATE_USER_PROFILE_FAILURE: // success handled in user reducer
        case types.UPDATE_USER_AVATAR_FAILURE:
        case types.DELETE_USER_AVATAR_FAILURE:
            console.log(action);
            return userProfileStore;

        case types.USER_PROFILE_SET_MFA_FACTORS:
            return Object.assign({}, userProfileStore, {
                allMFAFactors: action.data,
            });

        case types.USER_PROFILE_SET_SELECTED_MFA_FACTOR_ID:
            return Object.assign({}, userProfileStore, {
                selectedMFAFactorID: action.data,
            });

        case types.USER_PROFILE_SET_WAITING_FOR_MFA_RESPONSE:
            return Object.assign({}, userProfileStore, {
                waitingForMFAResponse: action.data,
            });

        case types.USER_PROFILE_SET_MFA_RESULT:
            return Object.assign({}, userProfileStore, {
                mfaResult: action.data,
            });

        case types.USER_PROFILE_SET_SHOW_MFA_ENROLLMENT_MODAL:
            return Object.assign({}, userProfileStore, {
                showMfaEnrollmentModal: action.data,
            });

        case types.USER_PROFILE_SET_MFA_ENROLLMENT_MODAL_TEXT:
            return Object.assign({}, userProfileStore, {
                mfaEnrollmentModalText: action.data,
            });

        case types.USER_PROFILE_SET_MFA_ENROLLMENT_UPDATED_THIS_SESSION:
            return Object.assign({}, userProfileStore, {
                mfaEnrollmentUpdatedThisSession: action.data,
            });

        default:
            return userProfileStore;
    }
};
